// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FontsList_wrapper__2F_T5","arrowWrapper":"FontsList_arrowWrapper__fadV1"};